import React from 'react';
import { Outlet } from 'react-router-dom';

import { SidebarProvider } from '@/components/ui/sidebar';

const SidebarLayout = () => (
  <SidebarProvider>
    <Outlet />
  </SidebarProvider>
);

export default SidebarLayout;
